import React from "react"
import { Link } from "gatsby"
import * as bookShowcaseCss from "./modules/book-showcase.module.scss"

const BookShowcase = ({ book }) => {
  return (
    <article className={bookShowcaseCss.shell}>
      <div className={bookShowcaseCss.core}>
        <figure className={bookShowcaseCss.visual}>
          <img src={book.cover} alt={book.coverAlt} />
        </figure>

        <div className={bookShowcaseCss.content}>
          <div className={bookShowcaseCss.topline}>
            <span>Livre à la une</span>
            <span>{book.status}</span>
          </div>

          <h2>{book.title}</h2>
          <p className={bookShowcaseCss.period}>{book.period}</p>
          <p className={bookShowcaseCss.description}>{book.description}</p>

          <dl className={bookShowcaseCss.details}>
            {book.details.map(detail => (
              <div key={detail.label}>
                <dt>{detail.label}</dt>
                <dd>{detail.value}</dd>
              </div>
            ))}
          </dl>

          <Link className={bookShowcaseCss.cta} to={book.href}>
            <span>{book.ctaLabel}</span>
            <span className={bookShowcaseCss.ctaIcon} aria-hidden="true">
              ↗
            </span>
          </Link>
        </div>
      </div>
    </article>
  )
}

export default BookShowcase
